var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"world"},[_c('ul',{staticClass:"slider__list"},_vm._l((_vm.texts),function(text){return _c('li',{key:text.title,staticClass:"list__item",style:({
        left: ((text.left) + "px"),
        transform: ("translate3d(" + (-_vm.scrollValue) + "px, -25%, 0)")
      })},[_vm._v("\n      "+_vm._s(text.title)+"\n    ")])})),_vm._v(" "),_c('div',{staticClass:"world__sticker"}),_vm._v(" "),_c('WorldFace')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07219562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/World.vue
// module id = 379
// module chunks = 3